<script lang="ts" setup>
import { computed } from 'vue'
import FeButton from '@/components/global/button.vue'
import type { LedWallEntityD } from '@/modules/fling/index.d'
import { useCatalogStore } from '@/abs-core/pages/catalog/composables/catalog'
import { storeToRefs } from 'pinia'

const props = withDefaults(
  defineProps<{
    image: string
  }>(),
  { image: '' },
)

const catalog = useCatalogStore()
const { ledWallInfo } = storeToRefs(catalog)

const listWall = computed(() => ledWallInfo.value)

function select(item: LedWallEntityD): void {
  catalog.setLedWallInfo({
    value: Object.assign({}, item, { image: props.image }),
    context: 'selectedLed',
  })
}
</script>

<template>
  <div class="fling-modal-list">
    <template v-for="(item, i) in listWall.list" :key="i">
      <fe-button
        v-if="item.flingAvailable"
        class="fling-modal-list__element"
        color=""
        @click="() => select(item)"
      >
        {{ item.positionDesc }}
      </fe-button>
    </template>
  </div>
</template>

<style scoped lang="scss">
.fling-modal-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 2rem;
  &__element {
    font-size: var(--font-size-sm);
    font-weight: 600;
    line-height: 1.9rem;
    letter-spacing: 0.03em;
    box-shadow: none;
    --background: transparent;
    min-width: 45%;
    margin-top: 1rem;
    border: 0.1rem solid rgba(0, 0, 0, 0.2);
  }
}
</style>
